import { makeStyles } from "@mui/styles";
import React, { useState } from "react";
import {
  Button,
  Card,
  Divider,
  FormControl,
  Grid,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import { getFarmer } from "../../../../redux/reducer/farmer/farmerReducer";
import moment from "moment";
import { PictureAsPdf } from "@mui/icons-material";
import { downloadData } from "../../../../service/Service";
import SpvReportActivityDetailTable from "./SpvReportActivityDetailTable";
import { getReportActivityDetail } from "../../../../redux/reducer/dailyActivity/reportDailyActivityReducer";
import { LoadingButton } from "@mui/lab";

const useStyles = makeStyles(() => ({
  headerClassSearch: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "column",
    padding: "0px 5px",
    margin: "10px 0px",
    background: "#F2F2F2",
  },
}));

export default function SpvReportActivityDetail() {
  // Styling
  const styles = useStyles();

  //Redux
  const data = useSelector((state) => state.reportDailyActivity.data.detail);
  const loading = useSelector((state) => state.reportDailyActivity.isLoading);
  const token = useSelector((state) => state.auth.token);
  const farmer = useSelector((state) => state.farmer.data);
  const dispatch = useDispatch();

  // Local State
  const [formInput, setFormInput] = useState({
    to: "",
    from: "",
    farmerId: "",
  });
  const [loadingDownload, setLoadingDownload] = useState(false);
  const [show, setShow] = useState(false);

  const handleChangeInput = (e) => {
    setFormInput({
      ...formInput,
      [e.target.name]: e.target.value,
    });
  };

  const checkingFilter = () => {
    let body = {
      farmerId: formInput.farmerId,
    };

    if (formInput.from) {
      if (formInput.to) {
        body = {
          ...body,
          createdAt: {
            $gte: moment(formInput.from).format(),
            $lte: moment(formInput.to).format(),
          },
        };
      } else {
        body = {
          ...body,
          createdAt: {
            $gte: moment(formInput.from).format(),
            $lte: moment(formInput.to)
              .add(23, "hours")
              .add(59, "minutes")
              .format(),
          },
        };
      }
    }

    let filterData = {
      token: token,
      body: {
        ...body,
      },
      params: {},
    };
    return filterData;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    dispatch(getReportActivityDetail(checkingFilter())).then((res) => {
      toast.success(res.payload.message);
      setShow(true);
    });
  };

  const handleReset = () => {
    setShow(false);
    setFormInput({
      to: "",
      from: "",
      farmerId: "",
    });
  };

  const loadMore = (value) => (event) => {
    if (
      event.target.scrollHeight - event.target.scrollTop < 300 &&
      event.target.scrollTop < 200
    ) {
      if (farmer.totalDocs !== farmer.docs.length && value === 1) {
        const getData = {
          params: {
            limit: farmer.limit + 10,
            page: 1,
          },
          token: token,
        };
        dispatch(getFarmer(getData));
      }
    }
  };

  const handleDownloadReport = () => {
    setLoadingDownload(true);
    const formData = {
      data: {
        farmerId: formInput.farmerId,
        createdAt: {
          $gte: moment(formInput.from).format(),
          $lte: moment(formInput.to).format(),
        },
      },
      token: token,
    };
    let x = farmer.docs.findIndex((item) => item._id === formInput.farmerId);
    let name = farmer.docs[x].fullName;
    downloadData(
      "/farmer/daily-activity/report/activity/detail/export",
      formData.token,
      formData.data
    )
      .then((response) => {
        console.log(response);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `LAPORAN_AKTIFITAS_PETANI_${name}_${moment(formInput.from).format(
            "DD-MMM-YYYY"
          )}_sampai_${moment(formInput.to).format("DD-MMM-YYYY")}.pdf`
        ); //or any other extension
        document.body.appendChild(link);
        link.click();
        setLoadingDownload(false);
      })
      .catch((err) => {
        if (err) {
          setLoadingDownload(false);
        }
      });
  };
  return (
    <>
      <ToastContainer />
      <Card className={styles.headerClassSearch}>
        <form onSubmit={handleSubmit} style={{ width: "100%" }}>
          <Grid padding={0.5} container spacing={0.5} flexDirection={"column"}>
            <Grid
              item
              container
              xs={12}
              sm={12}
              direction="row"
              alignItems="center"
              justifyContent={"space-between"}
            >
              <div
                style={{ display: "flex", alignItems: "center", width: "30%" }}
              >
                <Typography variant="h6" color="primary">
                  LAPORAN AKTIFITAS HARIAN PETANI
                </Typography>
              </div>
              <div style={{ display: "flex", width: "50%" }}>
                <FormControl
                  variant="standard"
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexDirection: "row",
                    width: "100%",
                    margin: "10px",
                  }}
                >
                  <TextField
                    InputLabelProps={{ shrink: true }}
                    label="Dari"
                    name="from"
                    size="small"
                    type="date"
                    required
                    onChange={handleChangeInput}
                    value={formInput.from}
                    variant="outlined"
                    style={{ width: "49%" }}
                  />
                  <TextField
                    InputLabelProps={{ shrink: true }}
                    label="Ke"
                    name="to"
                    size="small"
                    type="date"
                    required
                    onChange={handleChangeInput}
                    value={formInput.to}
                    variant="outlined"
                    style={{ width: "49%" }}
                  />
                </FormControl>
              </div>
            </Grid>
            <Divider style={{ width: "100%", border: "1px solid black" }} />
            <Grid
              item
              container
              xs={12}
              sm={12}
              direction="column"
              justifyContent="space-evenly"
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "80%",
                }}
              >
                <div style={{ width: "15%" }}>
                  <Typography>Petani</Typography>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "85%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <FormControl
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyItems: "flex-start",
                        width: "100%",
                        marginBottom: "10px",
                        flexDirection: "row",
                      }}
                    >
                      <TextField
                        select
                        InputLabelProps={{ shrink: true }}
                        required
                        size="small"
                        error={false}
                        name="farmerId"
                        onChange={handleChangeInput}
                        value={formInput.farmerId}
                        fullWidth
                        variant="outlined"
                        SelectProps={{
                          MenuProps: {
                            PaperProps: {
                              onScroll: loadMore(1),
                            },
                            style: {
                              height: "300px",
                              width: "100%",
                            },
                          },
                        }}
                        style={{
                          maxWidth: "400px",
                          background: "white",
                          marginRight: "10px",
                        }}
                      >
                        {farmer.docs.length > 0 ? (
                          farmer.docs.map((data, index) => (
                            <MenuItem value={data._id} key={index}>
                              {data.fullName}
                            </MenuItem>
                          ))
                        ) : (
                          <MenuItem value="">Data kosong</MenuItem>
                        )}
                      </TextField>
                    </FormControl>
                  </div>
                </div>
              </div>
            </Grid>
            <Grid
              container
              item
              justifyContent="flex-end"
              xs={12}
              sm={12}
              marginBottom={1}
            >
              <LoadingButton
                variant="contained"
                size="small"
                style={{ margin: "0px 5px" }}
                type="submit"
                loading={loading}
              >
                Submit
              </LoadingButton>
              <Button
                variant="contained"
                size="small"
                color="error"
                style={{ margin: "0px 10px" }}
                onClick={() => handleReset()}
              >
                Reset
              </Button>
            </Grid>
          </Grid>
        </form>
      </Card>

      <Card
        style={{
          padding: "10px",
          background: "#F2F2F2",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {show ? (
          <>
            <LoadingButton
              style={{
                margin: "20px 0px",
                backgroundColor: "#AE3336",
                width: "20%",
              }}
              variant="contained"
              loading={loadingDownload}
              onClick={() => handleDownloadReport()}
            >
              Download PDF
              <i style={{ alignItems: "center" }}>
                <PictureAsPdf />
              </i>
            </LoadingButton>
            <SpvReportActivityDetailTable data={data} />
          </>
        ) : (
          <Typography fontStyle={"italic"}>
            Silahkan Mengisi Form Terlebih Dahulu*{" "}
          </Typography>
        )}
      </Card>
    </>
  );
}
